export default __webpack_public_path__ + "8baf9ce7cbbeea6cff26bbbf57d97166.jpg";